import Card from 'react-bootstrap/Card';
import {  useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Spinner from 'react-bootstrap/Spinner';
import UserRegistrationEndpoint from '../../../api/endpoint/UserRegistrationEndpoint';

export const ConfirmUnregister = () => {
    const [isSuccess, setIsSuccess] = useState<boolean | undefined>(undefined);
    const [message, setMessage] = useState('');

    const location = useLocation();

    useEffect(() => {
        handleUnregister();
    }, []);

    const handleUnregister = async() => {
        try{
            const urlParams = new URLSearchParams(location.search);

            const hash = urlParams.get('user');
            const courseEventId = urlParams.get('course');

            if(!hash || hash === '') {
                setIsSuccess(false);
                setMessage('Error retrieving user email.');
                return;
            }

            if(!courseEventId || courseEventId === '') {
                setIsSuccess(false);
                setMessage('Error retrieving course event.');
                return;
            }

            const unregisterResult = await UserRegistrationEndpoint.UnregisterByEmail(hash, Number(courseEventId));

            if(!unregisterResult.errors || unregisterResult.errors.length == 0) {
                setIsSuccess(true);
                setMessage('You have successfully unregistered.');
            }
            else {
                setIsSuccess(false);
                setMessage(unregisterResult.errors.join(', '));
            }
        } catch(err) {
            setIsSuccess(false);
            setMessage('Errors returned: ' + (err instanceof Error ? err.message : String(err)));
        }
    };

    return (
        <Card style={{margin:'10% 25%'}}>
            <Card.Body>
                <Card.Title>
                    {isSuccess === undefined &&
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                    {isSuccess === true &&
                        <>Success!</>
                    }
                    {isSuccess === false &&
                        <>Error occurred while unregistering.</>
                    }
                </Card.Title>
                <Card.Body>
                    {message}
                </Card.Body>
            </Card.Body>
            
        </Card>
    )
}